import {Box, Pagination} from '@mui/material';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {getEntrancesByBuilding} from '../../actions';
import {Filters} from '../../components';
import EntrancesTable from '../../components/CustomTables/EntrancesTable';
import useFilters from '../../utils/useFilters';

const EntrancesTab = () => {
  const dispatch = useDispatch();
  const {id} = useParams();
  const {
    buildingEntrances,
    entrancesLoading,
    buildingEntrancesPage,
    buildingEntrancesTotalPages,
  } = useSelector(s => s.entrances);
  const filters = useFilters(val => dispatch(getEntrancesByBuilding(id, val)));

  const onPageChange = (e, value) => {
    dispatch(getEntrancesByBuilding(id, {page: value, ...filters.filters}));
  };

  return (
    <>
      <Box position="absolute" zIndex={1}>
        <Filters m="0 !important" withSearch {...filters} />
      </Box>
      <EntrancesTable
        entrances={buildingEntrances}
        loading={entrancesLoading}
      />
      {buildingEntrancesTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={buildingEntrancesTotalPages}
            page={buildingEntrancesPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </>
  );
};

export default EntrancesTab;
